module.exports = __webpack_public_path__ + "img/chair-3.c4f885e2.svg";